export const msalConfig = {
  auth: {
    clientId: "0405df75-3a28-4ae6-bed6-b5bc7d7d2424", // This is your application (client) ID
    authority: "https://login.microsoftonline.com/a2ee7c03-3aa8-40fa-bb2a-839f8212d3f3", // Replace with your tenant ID
    redirectUri: "http://localhost:8080" // Update to your redirect URI
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to true if you are in IE or old Edge
  }
};
